/* ============================================================
   pieszo — koszyk (drawer)
   Render pozycji z /cart.js, ilości, usuwanie, ochrona przesyłki,
   licznik rezerwacji, przechwycenie ikony koszyka i /cart/add.
   ============================================================ */
(function () {
  'use strict';

  var root, panel, overlay, itemsEl, scrollEl, emptyEl, footEl, countEl, subtotalEl, timerEl, protectInput;
  var savingsEl, savingsValueEl, upsellEl, upsellSelect, upsellImg;
  var discountsEl, wasEl;
  var moneyFormat, protectionVariant, reserveMinutes, upsellHandle;
  var cartState = null;
  var timerInterval = null;
  var productCache = {};

  /* ---------- ceny przed obniżką (cart.js ich nie zwraca) ---------- */
  function loadCompareData(cart) {
    var handles = [];
    cart.items.forEach(function (i) {
      if (i.handle && !productCache[i.handle] && handles.indexOf(i.handle) === -1) handles.push(i.handle);
    });
    if (!handles.length) return Promise.resolve();
    return Promise.all(handles.map(function (h) {
      return fetch('/products/' + h + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) { if (p) productCache[h] = p; })
        .catch(function () {});
    }));
  }

  function compareUnitOf(item) {
    var p = productCache[item.handle];
    if (!p) return 0;
    var v = null;
    for (var i = 0; i < p.variants.length; i++) {
      if (p.variants[i].id === item.variant_id) { v = p.variants[i]; break; }
    }
    if (!v || !v.compare_at_price) return 0;
    return v.compare_at_price > item.price ? v.compare_at_price : 0;
  }

  function formatMoney(cents, format) {
    /* bez tego bledna wartosc wyswietla sie klientowi jako "NaN zl" */
    var kwota = Number(cents);
    if (!isFinite(kwota)) kwota = 0;
    var amount = (kwota / 100).toFixed(2);
    var withComma = amount.replace('.', ',');
    var f = format || '{{amount_with_comma_separator}} zł';
    return f
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(kwota / 100).toString())
      .replace(/\{\{\s*amount\s*\}\}/, amount);
  }

  /* Shopify zwraca rabaty w DWOCH ksztaltach:
       /cart.js          -> { title, total_allocated_amount, ... }
       /cart/change.js   -> { amount, discount_application: { title, ... } }
     Bez ujednolicenia po zmianie ilosci w koszyku wychodzilo "Rabat za zestaw  -NaN zl". */
  function czytajRabat(d) {
    var app = d.discount_application || d;
    var kwota = [d.total_allocated_amount, d.amount, app.total_allocated_amount]
      .filter(function (x) { return typeof x === 'number' && isFinite(x); })[0];
    return { tytul: (app.title || d.title || '').trim(), kwota: kwota };
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function plural(n) {
    if (n === 1) return 'produkt';
    var d = n % 10, h = n % 100;
    if (d >= 2 && d <= 4 && (h < 12 || h > 14)) return 'produkty';
    return 'produktów';
  }

  function imgUrl(src, size) {
    if (!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + size;
  }

  /* ---------- render ---------- */
  function render(cart) {
    cartState = cart;
    var hasItems = cart.item_count > 0;

    countEl.textContent = hasItems ? cart.item_count + ' ' + plural(cart.item_count) : '';
    emptyEl.hidden = hasItems;
    footEl.hidden = !hasItems;
    if (scrollEl) scrollEl.style.display = hasItems ? '' : 'none';
    subtotalEl.textContent = formatMoney(cart.total_price, moneyFormat);

    // ---- rabaty naliczone przez Shopify: pokazujemy je wprost, zeby klient
    //      widzial ILE zyskuje, a nie tylko koncowa kwote ----
    var rabaty = cart.cart_level_discount_applications || [];
    var rabatRazem = cart.total_discount || 0;
    if (discountsEl) {
      if (rabatRazem > 0) {
        var wiersze = '';
        if (rabaty.length) {
          rabaty.forEach(function (d) {
            var r = czytajRabat(d);
            // tytuly typu "-99 zloty" nic nie mowia - zastepujemy czytelna etykieta
            var tytul = r.tytul;
            if (!tytul || /^[-−+]?\s*\d/.test(tytul)) tytul = 'Rabat za zestaw';
            // gdy pojedynczy rabat nie poda kwoty, bierzemy sume rabatow z koszyka
            var kwota = r.kwota;
            if (kwota == null) kwota = rabaty.length === 1 ? rabatRazem : null;
            if (kwota == null) return;
            wiersze += '<div class="pz-cart-discount-row"><span>' + esc(tytul) +
                       '</span><span>−' + formatMoney(kwota, moneyFormat) + '</span></div>';
          });
        }
        if (!wiersze) {
          wiersze = '<div class="pz-cart-discount-row"><span>Rabat</span><span>−' +
                    formatMoney(rabatRazem, moneyFormat) + '</span></div>';
        }
        discountsEl.innerHTML = wiersze;
        discountsEl.hidden = false;
      } else {
        discountsEl.hidden = true;
        discountsEl.innerHTML = '';
      }
    }
    // suma sprzed rabatu - przekreslona obok kwoty do zaplaty
    if (wasEl) {
      if (rabatRazem > 0 && cart.items_subtotal_price > cart.total_price) {
        wasEl.textContent = formatMoney(cart.items_subtotal_price, moneyFormat);
        wasEl.hidden = false;
      } else {
        wasEl.hidden = true;
      }
    }

    var protectionInCart = false;
    var upsellInCart = false;
    var savings = 0;
    var html = '';
    cart.items.forEach(function (item) {
      if (upsellHandle && item.handle === upsellHandle) upsellInCart = true;
      var compareUnit = compareUnitOf(item);
      if (compareUnit) savings += (compareUnit - item.price) * item.quantity;
      if (protectionVariant && item.variant_id === protectionVariant) {
        protectionInCart = true;
        return; // ochrona przesyłki ma własny moduł w stopce
      }
      var variantBits = [];
      if (item.variant_title) variantBits.push(esc(item.variant_title));
      if (item.properties) {
        Object.keys(item.properties).forEach(function (k) {
          if (k.charAt(0) === '_' || !item.properties[k]) return;
          variantBits.push(esc(k) + ': ' + esc(item.properties[k]));
        });
      }
      html +=
        '<div class="pz-cart-item" data-key="' + esc(item.key) + '">' +
          '<div class="pz-cart-item-img">' +
            (item.image ? '<img src="' + esc(imgUrl(item.image, 200)) + '" alt="' + esc(item.product_title) + '" loading="lazy">' : '') +
          '</div>' +
          '<div>' +
            '<div class="pz-cart-item-top">' +
              '<a class="pz-cart-item-title" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' +
              '<button type="button" class="pz-cart-item-remove" data-pz-remove aria-label="Usuń z koszyka">' +
                '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M4 7h16M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2M6.5 7l1 12.2a1.5 1.5 0 0 0 1.5 1.3h6a1.5 1.5 0 0 0 1.5-1.3l1-12.2M10 11v6M14 11v6"/></svg>' +
              '</button>' +
            '</div>' +
            (variantBits.length ? '<p class="pz-cart-item-variant">' + variantBits.join('<br>') + '</p>' : '') +
            '<div class="pz-cart-item-bottom">' +
              '<div class="pz-cart-qty">' +
                '<button type="button" data-pz-qty="-1" aria-label="Zmniejsz ilość"' + (item.quantity <= 1 ? ' disabled' : '') + '>−</button>' +
                '<span>' + item.quantity + '</span>' +
                '<button type="button" data-pz-qty="1" aria-label="Zwiększ ilość">+</button>' +
              '</div>' +
              '<span class="pz-cart-item-price">' +
                (compareUnit ? '<s class="pz-cart-item-was">' + formatMoney(compareUnit * item.quantity, moneyFormat) + '</s> ' : '') +
                '<span class="pz-cart-item-now">' + formatMoney(item.final_line_price, moneyFormat) + '</span>' +
              '</span>' +
            '</div>' +
          '</div>' +
        '</div>';
    });
    itemsEl.innerHTML = html;
    if (protectInput) protectInput.checked = protectionInCart;

    // ile klient oszczędza
    if (savingsEl && savingsValueEl) {
      if (savings > 0) {
        savingsValueEl.textContent = '−' + formatMoney(savings, moneyFormat);
        savingsEl.hidden = false;
      } else {
        savingsEl.hidden = true;
      }
    }

    // upsell: pokaż tylko gdy koszyk ma produkty i smyczy jeszcze w nim nie ma
    if (upsellEl) upsellEl.hidden = !hasItems || upsellInCart;
  }

  /* ---------- API ---------- */
  function refresh() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        return loadCompareData(cart).then(function () {
          render(cart); updateBubble(); return cart;
        });
      });
  }

  function changeLine(key, quantity) {
    itemsEl.classList.add('pz-cart-busy');
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { return loadCompareData(cart).then(function () { render(cart); updateBubble(); }); })
      .finally(function () { itemsEl.classList.remove('pz-cart-busy'); });
  }

  function addVariant(id) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    }).then(function () { return refresh(); });
  }

  function updateBubble() {
    // licznik przy ikonie koszyka w nagłówku pieszo
    if (cartState) {
      document.querySelectorAll('[data-pz-cart-bubble]').forEach(function (b) {
        b.textContent = cartState.item_count;
        b.hidden = cartState.item_count === 0;
      });
    }
  }

  /* ---------- otwieranie / zamykanie ---------- */
  function open() {
    overlay.hidden = false;
    panel.hidden = false;
    void panel.offsetWidth; // wymuszony reflow, by transycja zadziałała bez rAF
    overlay.classList.add('is-open');
    panel.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    startTimer();
    refresh();
  }

  function close() {
    overlay.classList.remove('is-open');
    panel.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    setTimeout(function () { overlay.hidden = true; panel.hidden = true; }, 300);
  }

  /* ---------- licznik rezerwacji ---------- */
  function startTimer() {
    if (!timerEl || !reserveMinutes) return;
    var end = parseInt(sessionStorage.getItem('pzCartTimerEnd') || '0', 10);
    var now = Date.now();
    if (!end || end <= now) {
      end = now + reserveMinutes * 60000;
      sessionStorage.setItem('pzCartTimerEnd', String(end));
    }
    clearInterval(timerInterval);
    var tick = function () {
      var left = Math.max(0, Math.floor((end - Date.now()) / 1000));
      var m = String(Math.floor(left / 60)).padStart(2, '0');
      var s = String(left % 60).padStart(2, '0');
      timerEl.textContent = m + ':' + s;
      if (left <= 0) {
        end = Date.now() + reserveMinutes * 60000;
        sessionStorage.setItem('pzCartTimerEnd', String(end));
      }
    };
    tick();
    timerInterval = setInterval(tick, 1000);
  }

  /* ---------- init ---------- */
  function init() {
    root = document.querySelector('[data-pz-cart]');
    if (!root) return;
    panel = root.querySelector('[data-pz-cart-panel]');
    overlay = root.querySelector('[data-pz-cart-overlay]');
    itemsEl = root.querySelector('[data-pz-cart-items]');
    scrollEl = root.querySelector('[data-pz-cart-scroll]');
    emptyEl = root.querySelector('[data-pz-cart-empty]');
    footEl = root.querySelector('[data-pz-cart-foot]');
    countEl = root.querySelector('[data-pz-cart-count]');
    subtotalEl = root.querySelector('[data-pz-cart-subtotal]');
    timerEl = root.querySelector('[data-pz-cart-timer]');
    protectInput = root.querySelector('[data-pz-cart-protect]');
    savingsEl = root.querySelector('[data-pz-cart-savings]');
    discountsEl = root.querySelector('[data-pz-cart-discounts]');
    wasEl = root.querySelector('[data-pz-cart-was]');
    savingsValueEl = root.querySelector('[data-pz-cart-savings-value]');
    upsellEl = root.querySelector('[data-pz-cart-upsell]');
    upsellSelect = root.querySelector('[data-pz-cart-upsell-variant]');
    upsellImg = root.querySelector('[data-pz-upsell-cart-img]');

    moneyFormat = root.getAttribute('data-money-format') || '';
    protectionVariant = parseInt(root.getAttribute('data-protection-variant') || '0', 10) || 0;
    reserveMinutes = parseInt(root.getAttribute('data-reserve-minutes') || '0', 10) || 0;
    upsellHandle = root.getAttribute('data-upsell-handle') || '';

    // upsell: podmiana zdjęcia przy zmianie wariantu + dodanie do koszyka
    if (upsellSelect && upsellImg && upsellSelect.tagName === 'SELECT') {
      var syncUpsellImg = function () {
        var opt = upsellSelect.options[upsellSelect.selectedIndex];
        var src = opt ? opt.getAttribute('data-img') : null;
        if (src && upsellImg.getAttribute('src') !== src) upsellImg.src = src;
      };
      upsellSelect.addEventListener('change', syncUpsellImg);
      syncUpsellImg();
    }
    var upsellAddBtn = root.querySelector('[data-pz-cart-upsell-add]');
    if (upsellAddBtn && upsellSelect) {
      upsellAddBtn.addEventListener('click', function () {
        var id = parseInt(upsellSelect.value, 10);
        if (!id) return;
        upsellAddBtn.disabled = true;
        var label = upsellAddBtn.textContent;
        upsellAddBtn.textContent = 'Dodaję…';
        addVariant(id).finally(function () {
          upsellAddBtn.disabled = false;
          upsellAddBtn.textContent = label;
        });
      });
    }

    root.querySelectorAll('[data-pz-cart-close]').forEach(function (b) { b.addEventListener('click', close); });
    overlay.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panel.hidden) close(); });

    // delegacja: ilości i usuwanie
    itemsEl.addEventListener('click', function (e) {
      var removeBtn = e.target.closest('[data-pz-remove]');
      var qtyBtn = e.target.closest('[data-pz-qty]');
      var row = e.target.closest('.pz-cart-item');
      if (!row) return;
      var key = row.getAttribute('data-key');
      var item = (cartState.items || []).find(function (i) { return i.key === key; });
      if (!item) return;
      if (removeBtn) { changeLine(key, 0); return; }
      if (qtyBtn) {
        var next = item.quantity + parseInt(qtyBtn.getAttribute('data-pz-qty'), 10);
        changeLine(key, Math.max(0, next));
      }
    });

    // ochrona przesyłki
    if (protectInput && protectionVariant) {
      protectInput.addEventListener('change', function () {
        if (protectInput.checked) {
          addVariant(protectionVariant);
        } else {
          var line = (cartState.items || []).find(function (i) { return i.variant_id === protectionVariant; });
          if (line) changeLine(line.key, 0);
        }
      });
    }

    // do kasy
    var checkoutBtn = root.querySelector('[data-pz-cart-checkout]');
    if (checkoutBtn) checkoutBtn.addEventListener('click', function () { window.location.href = '/checkout'; });

    // przechwycenie kliknięcia w ikonę koszyka / linki do /cart
    document.addEventListener('click', function (e) {
      var link = e.target.closest('a[href$="/cart"], a[href*="/cart?"], #cart-icon-bubble');
      if (!link) return;
      e.preventDefault();
      e.stopPropagation();
      open();
    }, true);

    // każde dodanie do koszyka (fetch na /cart/add) otwiera drawer
    var origFetch = window.fetch;
    window.fetch = function () {
      var url = typeof arguments[0] === 'string' ? arguments[0] : (arguments[0] && arguments[0].url) || '';
      var p = origFetch.apply(this, arguments);
      if (url.indexOf('/cart/add') > -1) {
        p.then(function (res) {
          if (res.ok) setTimeout(open, 50);
        }).catch(function () {});
      }
      return p;
    };

    // zdarzenia zewnętrzne (np. buy box landinga)
    document.addEventListener('pieszo:cart:open', open);

    refresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
